module.exports = "/images/img-4.jpg?73650b241d7b39c8385a6c49ab2c1e2b";